import Button from '@anm/components/buttons/Button';
import { useCallback, FC } from 'react';

import useStreamPaging from '../hooks/useStreamPaging';

import { Wrapper } from './Wrapper';

const Pagination: FC = () => {
  const [isPrevButtonVisible, isNextButtonVisible, handleNextPage, handlePrevPage] = useStreamPaging();

  const scrollTop = () => window.scrollTo({ top: 0 });

  const onPrevButtonClick = useCallback(() => {
    scrollTop();
    handlePrevPage();
  }, [scrollTop, handlePrevPage]);

  const onNextButtonClick = useCallback(() => {
    scrollTop();
    handleNextPage();
  }, [scrollTop, handleNextPage]);

  return (
    <Wrapper>
      {isPrevButtonVisible && (
        <Button variant="silver" size="medium" onClick={onPrevButtonClick}>
          Previous page
        </Button>
      )}
      {isNextButtonVisible && (
        <Button variant="silver" size="medium" onClick={onNextButtonClick}>
          Next page
        </Button>
      )}
    </Wrapper>
  );
};

export default Pagination;
